module.exports = __webpack_public_path__ + "img/fish.2fbd8e2d.svg";